import React, { useState, useEffect } from "react";
import "./footer.css";
import { CheckCircleTwoTone, DisconnectOutlined } from "@ant-design/icons";
const FooterComponent = () => {
  const [connectivity, setConnectivity] = useState(true);

  useEffect(() => {
    function changeStatus() {
      setConnectivity(navigator.onLine);
    }
    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);

  return (
    <div id="footer">
      <p className="copyRight">
        &copy; Copyright {new Date().getFullYear()} Krrave Technologies {connectivity ? <span className="notified active">Online</span> : <span className="notified">Offline</span>}
        {/* <p style={{marginBottom: 0}}></p> */}
      </p>
    </div>
  );
};
export default FooterComponent;
